import React, { useState } from "react";
import { Button, Modal } from "antd";
const App = (props) => {
  return (
    <>
      <Modal
        okText={props.okText}
        title={props.title}
        centered
        open={props.open}
        onOk={() => {
          props.handleOk();
        }}
        onCancel={() => {
            console.log(props,"props")
          props.handleCancel();
        }}
        width={600}
      >
        <p>{props.content}</p>
      </Modal>
    </>
  );
};
export default App;
